import axios from "axios";

const initializeApp = () => {
  // Setting base URL for all API request via axios
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  // Note: 401 handling for axios is done in auth.js interceptors.
  //       401 handling for RTK Query (apiSlice) is done via baseQueryWithReauth
  //       which attempts a token refresh before redirecting to login.

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    // dev code
  } else {
    // Prod build code

    // Removing console.log from prod
    console.log = () => {};

    // init analytics here
  }
};

export default initializeApp;
